import React from 'react'
import styled from 'styled-components'
import Title from './Title'
import BodyText from './BodyText'
import Btn from './BtnLink'
import media from '../../utils/media'

const Container = styled.div`
  margin-top: ${props => props.marginTCont}px;
  margin-bottom: ${props => props.marginBCont}px;
  ${media.mobileL`
    margin-top: calc(${props => props.marginTCont}px/3);
    margin-bottom: calc(${props => props.marginBCont}px/3);
  `}
  text-align: center;
`

const Wrapper = styled.div`
  margin: auto ${props => (props.verticalPadding ? '20%' : 0)};
  p {
    line-height: 1.5;
  }
  ${media.tablet`
    margin: auto ${props => (props.verticalPadding ? '5%' : 0)};
  `}
  ${media.mobileL`
    margin: auto 0;
  `}
`

export default function Intro({
  marginTCont,
  marginBCont,
  verticalPadding,
  title,
  titleSize,
  titleColor,
  titleFamily,
  text,
  textTwo,
  textSize,
  textColor,
  fontFamily,
  btnText,
  href,
  btnBg,
  btnColor,
  btnMarginT,
  btnMarginB,
}) {
  return (
    <Container marginBCont={marginBCont} marginTCont={marginTCont}>
      <Title
        title={title}
        titleSize={titleSize}
        titleColor={titleColor}
        titleFamily={titleFamily}
      />
      <Wrapper verticalPadding={verticalPadding}>
        <BodyText
          text={text}
          textSize={textSize}
          textColor={textColor}
          fontFamily={fontFamily}
        />
      </Wrapper>
      {textTwo && (
        <Wrapper verticalPadding={verticalPadding}>
          <BodyText
            text={textTwo}
            textSize={textSize}
            textColor={textColor}
            fontFamily={fontFamily}
          />
        </Wrapper>
      )}
      {btnText && (
        <Btn
          btnText={btnText}
          href={href}
          btnBg={btnBg}
          btnColor={btnColor}
          btnMarginT={btnMarginT}
          btnMarginB={btnMarginB}
        />
      )}
    </Container>
  )
}
